export default "__VITE_ASSET__Bry0eY2I__"